import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import heroImage from "../../static/media/AboutUs/main.webp";

const MotionBox = motion(Box);
const MotionTypography = motion(Typography);

export default function AboutIntroSection() {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        width: "100%",
        minHeight: { xs: "60vh", md: "75vh" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <MotionBox
        initial={{ scale: 1.08, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "brightness(0.55) contrast(1.1)",
          zIndex: 0,
        }}
      />

      <MotionBox
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut", delay: 0.15 }}
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(120deg, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.55) 45%, rgba(229,9,20,0.25) 100%)",
          zIndex: 1,
        }}
      />

      <Container
        maxWidth="md"
        sx={{
          position: "relative",
          zIndex: 2,
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <MotionTypography
          component="h1"
          initial={{ opacity: 0, y: 34 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.85, ease: "easeOut", delay: 0.2 }}
          sx={{
            fontSize: {
              xs: "clamp(36px, 8vw, 48px)",
              md: "clamp(52px, 5vw, 68px)",
            },
            fontWeight: 800,
            color: "#ffffff",
            lineHeight: 1.05,
            letterSpacing: -2,
            textShadow: "0 8px 35px rgba(0,0,0,0.65)",
          }}
        >
          Más que un gimnasio,
          <Box
            component={motion.span}
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.38 }}
            sx={{
              display: "block",
              color: "#ff2a2a",
              fontWeight: 800,
            }}
          >
            una comunidad
          </Box>
        </MotionTypography>

        <MotionTypography
          initial={{ opacity: 0, y: 26 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
          sx={{
            mt: 3,
            fontSize: { xs: 16, md: 18 },
            lineHeight: 1.85,
            color: "rgba(255,255,255,0.88)",
            fontWeight: 500,
            maxWidth: 620,
            textShadow: "0 6px 25px rgba(0,0,0,0.5)",
            mx: { xs: "auto", md: 0 },
          }}
        >
          Con más de 10 años de experiencia transformando vidas, aquí no vienes
          solo a entrenar. Vienes a romper límites, a superarte y a formar parte
          de algo más grande.
        </MotionTypography>

        <MotionTypography
          initial={{ opacity: 0, y: 26 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.66 }}
          sx={{
            mt: 2,
            fontSize: { xs: 16, md: 18 },
            lineHeight: 1.85,
            color: "rgba(255,255,255,0.88)",
            fontWeight: 500,
            maxWidth: 620,
            textShadow: "0 6px 25px rgba(0,0,0,0.5)",
            mx: { xs: "auto", md: 0 },
          }}
        >
          En NovaXFit creemos que el entrenamiento va más allá del ejercicio.
          Construimos hábitos, disciplina y una mentalidad fuerte que impacta tu
          vida dentro y fuera del gimnasio.
        </MotionTypography>
      </Container>
    </Box>
  );
}